<template>
  <DxPopup @hidden="onHidden" :visible="makePop" :show-close-button="true" :show-title="true" :title="'ITP Information Request Final block'" :height= window.h :width= window.w container=".v-application">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="'Information Request ITP'"
          :useBtnList="useBtnList"
          @btnRetrieve="btnRetrieve" @btnApplyRequest="btnApplyRequest" @btnClose="btnClose"
        >
          <template v-slot:body>
            <v-layout column >
              <v-row no-gutters>
                <v-col cols="12">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                  >
                    <template v-slot:body>
                      <v-row no-gutters class="center pa-0 pl-1">
                        <v-col cols="12">
                          <v-row dense>
                            <v-icon x-small color="blue" class="pt-1">mdi-circle</v-icon>
                            <span class="pa-2 pr-0 subText">Supplier name : </span>
                            <v-col cols="3">
                              <v-select
                                v-model="custCd"
                                :label="custCd"
                                :items="custCdList"
                                item-value="custCd"
                                return-object
                                single-line
                                outlined
                                dense
                              ></v-select>
                            </v-col>
                            <v-icon x-small color="blue" class="pl-2 pt-1">mdi-circle</v-icon>
                            <span class="pa-2 pr-0 subText" >Ship No : </span>
                            <v-col cols="1" >
                              <v-text-field
                                dense 
                                outlined 
                                hide-details="auto"
                                clearable 
                                maxLength="8"
                                v-model="shipNo"
                              />
                            </v-col>
                            <v-icon x-small color="blue" class="pl-2 pt-1">mdi-circle</v-icon>
                            <span class="pa-2 pr-0 subText">QM Part : </span>
                            <v-col cols="1" >
                              <v-select
                                v-model="reqQmPart"
                                :items="reqQmPartList"
                                :label="reqQmPart"
                                item-value="reqQmPart"
                                return-object
                                single-line
                                outlined
                                dense
                                disabled
                              ></v-select>
                            </v-col>
                            <v-icon x-small color="blue" class="pl-2 pt-1">mdi-circle</v-icon>
                            <span class="pa-2 pr-0 subText">Block Search : </span>
                            <v-col cols="1" >
                              <v-text-field
                                dense 
                                outlined 
                                hide-details="auto"
                                clearable 
                                maxLength="4"
                                v-model="block"
                                @keyup="uppercase"
                                v-on:keyup.enter="btnRetrieve"
                              />
                            </v-col>
                          </v-row>
                          <v-row dense class="ma-0">
                            <v-icon x-small color="blue" class="pt-1">mdi-circle</v-icon>
                            <span class="pa-2 pr-0 subText">Inspection Kind : </span>
                            <v-col cols="2">
                              <v-select
                                v-model="kindCd"
                                :items="kindCdList"
                                :label="kindCd"
                                item-value="kindCd"
                                return-object
                                single-line
                                outlined
                                dense
                                @change="btnRetrieve"
                              ></v-select>
                            </v-col>
                            <v-icon x-small color="blue" class="pl-2 pt-1">mdi-circle</v-icon>
                            <span class="pa-2 pr-0 subText">Insp. date/Time : </span>
                            <v-col cols="2">
                              <DxDateBox
                                :value="insDate"
                                height="30px"
                                display-format="yyyy-MM-dd"
                                :acceptCustomValue="false"
                              />
                            </v-col>
                            <v-col cols="1" class="pl-0">
                              <v-select
                                v-model="insTime"
                                :items="insTimeList"
                                item-value="codeName"
                                item-text="timeNm"
                                return-object
                                single-line
                                outlined
                                dense
                              ></v-select>
                            </v-col>
                            <v-icon x-small color="blue" class="pl-2 pt-1">mdi-circle</v-icon>
                            <span class="pa-2 pr-0 subText">LQC member : </span>
                            <v-col cols="1" >
                              <v-select
                                v-model="empNo"
                                :items="empNoList"
                                :label="empNo"
                                item-value="empNo"
                                return-object
                                single-line
                                outlined
                                dense
                              ></v-select>
                            </v-col>
                            <v-icon x-small color="blue" class="pl-2 pt-1">mdi-circle</v-icon>
                            <span class="pa-2 pr-0 subText">Insp. Place : </span>
                            <v-col cols="1" >
                              <v-select
                                v-model="inspLoc"
                                :items="inspLocList"
                                item-value="inspLoc"
                                return-object
                                single-line
                                outlined
                                dense
                              ></v-select>
                            </v-col>
                          </v-row>

                        </v-col>
                      </v-row>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12" class="pt-2">
                  <DxDataGrid id="v80a1040Make"
                    :ref="v80a1040MakeRef"
                    :height= window.hDx
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="false"
                    :column-hiding-enabled="false"
                  >
                    <DxColumn data-field="id" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false" :visible="true" />
                    <DxColumn data-field="shipNo" caption="Ship No" width="7%" data-type="string" alignment="center" :allow-editing="false" :visible="true" />
                    <DxColumn data-field="block" caption="block" width="7%" data-type="string" alignment="center" :allow-editing="false" :visible="true" />
                    <DxColumn data-field="eqYn" caption="EQ" width="4%" data-type="boolean" alignment="center" :allow-editing="false" edit-cell-template="eqChk" />
                    <template #eqChk="{ data: cellInfo }">
                      <div :style="cellInfo.value === 'Y' || cellInfo.value === 'N' ? '' : 'display: none'">
                        <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :onValueChanged="value => onValueChanged2(value, cellInfo)" />
                      </div>
                    </template>

                    <DxColumn data-field="kindCd" caption="Kind of insp" width="15%" data-type="string" alignment="center" :allow-editing="true" :visible="true" >
                      <DxLookup :data-source="kindInspList" display-expr="codeName" value-expr="code" />
                    </DxColumn>
                    <DxColumn data-field="inspAct" caption="Activity No" width="15%" data-type="string" alignment="center" :allow-editing="false" :visible="true" />
                    <DxColumn data-field="itemDesc" caption="Inspection Items" width="20%" data-type="string" alignment="center" :allow-editing="false" :visible="true" />
                    <DxColumn data-field="remark" caption="Remark" width="28%" data-type="string" alignment="center" :allow-editing="true" :visible="true" />
                    <DxColumn data-field="inspStat" caption="Status" width="5%" data-type="string" alignment="center" :allow-editing="false" :visible="true" />


                    <DxPaging :enabled="true" :page-size="19" />
                    <!-- <DxPager :visible="false" /> -->
                  </DxDataGrid>
                  <span style="font-weight: bold;">Count Total: {{ totalRow }} Row(s)</span>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
import { DxDataGrid, DxEditing, DxColumn , DxPager ,DxLookup } from 'devextreme-vue/data-grid'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import { getAddList , v80a1040Save } from '@/api/view/hip/8/v80a1040Popup.js'
import notify from 'devextreme/ui/notify' // message

export default {
  name: 'v80a1040MakePop',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxPopup,
    ICardVertical,
    iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPager,
    DxDateBox,
    DxLookup
  },
  props: {
    makePop: {
      type: Boolean,
      default() { return false }
    },
    makePopData: {
      type: Array,
      default() { return }
    },
    supNameList: {
      type: Array,
      default() { return }
    },
    qmPartList: {
      type: Array,
      default() { return }
    },
    inspectionList: {
      type: Array,
      default() { return }
    },
    insTimeListPop: {
      type: Array,
      default() { return }
    },
    lqcMemberListPop: {
      type: Array,
      default() { return }
    },
    inspLocListPop: {
      type: Array,
      default() { return }
    },
    kindInspListPop: {
      type: Array,
      default() { return }
    },
  },
  data() {
    return {
      useBtnList: ['btnRetrieve' , 'btnApplyRequest' , 'btnClose'],
      v80a1040MakeRef: 'v80a1040MakeRef',
      gridMainList: [],
      totalRow: 0,

      fileName: '',
      remark: '',

      custCd: '',
      custCdList: this.supNameList,
      shipNo: '',
      reqQmPart: '',
      reqQmPartList: [],
      block: '',
      kindCd: '',
      kindCdList: this.inspectionList,
      insDate: '',
      insTime: '',
      insTimeList: [],
      empNo: '',
      empNoList: [],
      empNoList2: [],
      inspLoc: '',
      inspLocList: [],
      inspLocList2: [],

      kindInspList: this.kindInspListPop,

      window: {
            w: 0,
            h: 0,
            hDx: 0
      }

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.v80a1040MakeRef)
    },
  },
  watch: {
    'makePop': {
      handler(value, oldValue) {
        if(value) {
          this.fileName = ''
          this.remark = ''
          this.custCd = ''
          this.custCdList = this.supNameList
          this.shipNo = ''
          this.reqQmPart = ''
          this.reqQmPartList = []
          this.block = ''
          this.kindCd = ''
          this.kindCdList = this.inspectionList
          this.insDate = ''
          this.insTime = ''
          this.insTimeList = []
          this.empNo = ''
          this.empNoList = []
          this.empNoList2 = []
          this.inspLoc = ''
          this.inspLocList = []
          this.inspLocList2 = []
          this.kindInspList = this.kindInspListPop
         
          //
          this.supNameList.forEach(e => {
            let filter = []
            filter = e.split(' : ')
            if(filter[0] === this.makePopData.custCd){
              this.custCd = e
            }
          });
          this.shipNo = this.makePopData.shipNo
          this.reqQmPart = this.makePopData.qmPart
          this.reqQmPartList.push(this.qmPartList[0] , this.qmPartList[1])
          this.insDate = this.makePopData.stDate
          this.insTimeList = this.insTimeListPop
          this.lqcMemberListPop.forEach(e => {
            this.empNoList.push(e.enm)
            this.empNoList2.push(e)
          });
          this.inspLocList.push('')
          this.inspLocListPop.forEach(e => {
            this.inspLocList.push(e.codeName)
            this.inspLocList2.push(e)
          });
          this.kindCd = this.kindCdList[0]
          this.empNo = this.empNoList[0]
          this.doSearchMain()

          window.addEventListener('resize', this.handleResize)
          window.removeEventListener('resize', this.handleResize)
          this.handleResize()

        }
      },
      immediate: true
    }
  },
  mounted(){
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.gridMainInstance.option('defaultPaging', false)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.w   = window.innerWidth - 100;
      this.window.h   = window.innerHeight - 100;
      this.window.hDx = window.innerHeight - 380;
    },
    onHidden(e) {
      this.$emit('update:makePop', false)
    },
    isSave(saveData) {
      this.$emit('isSaved', saveData)
    },
    async doSearchMain(){
      this.gridMainList = []
      this.totalRow = '0'
      let filter = []
	  	filter = this.custCd.split(' : ')
      let kindCd = ''
      switch(this.kindCd){
        case 'Select...' : kindCd = ''
          break
        case 'Final Inspection' : kindCd = 'FIN'
          break
        case 'Filler Air Test' : kindCd = 'AIT'
          break
        case 'QM Inspection' : kindCd = 'INS'
          break
        case 'Dimension check' : kindCd = 'DIM'
          break
        case 'Installation & Function inspection' : kindCd = 'IFU'
          break  
      }

      let params = {
        shipNo: this.shipNo,
        qmPart: this.reqQmPart === 'Hull' ? 'H' : 'M',
        block: !this.block ? '' : this.block,
        kindCd: kindCd,
        custCd: filter[0]
      }
      await getAddList(params).then(res => {
        if(res.list.length){
          let cnt = 1
          res.list.forEach(e => {
            e.id = cnt++
          });
          this.gridMainList = res.list
          this.totalRow = this.gridMainList.length
        }
      })
    },
    btnRetrieve(){
      this.doSearchMain()
    },
    async btnApplyRequest(){

      // console.log('btnApplyRequest')

      if(!this.empNo){
        this.vToastify(this.$t('Please select LQC membert!'), 'warn')
        return
      }
      if(!this.inspLoc){
        this.vToastify(this.$t('Please select Inspection place!'), 'warn')
        return
      }

      await this.gridMainInstance.saveEditData()
      var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
      let minDate = new Date
      minDate.setDate(minDate.getDate() + 1);

      if(!selectedMainRows.length){
        this.vToastify(this.$t('Data is not selected!.'), 'warn')
        return
      }else {
        for(let i = 0; i < selectedMainRows.length; i++){
          if(!this.shipNo){ this.shipNo = selectedMainRows[i].shipNo }

          if(selectedMainRows[i].shipNo != this.shipNo){
            this.vToastify(this.$t('Ship No is different.'), 'warn')
            return
          }

          if(!this.insDate){
            this.vToastify(this.$t('Select Inspection Date.'), 'warn')
            return
          }
          if(!this.insTime.codeName){
            this.vToastify(this.$t('Select Inspection Time.'), 'warn')
            return
          }
          if(this.insDate < minDate){
            this.vToastify(this.$t('You can not inspection request the inspection of this day. You select Inspection Date over today please!'), 'warn')
            return
          }
          selectedMainRows[i].insDate = this.insDate
          selectedMainRows[i].insTime = this.insTime.codeName
          selectedMainRows[i].userId = this.$store.state.user.userId

          for(let a = 0; a < this.inspLocList2.length; a++){
            if(this.inspLoc == this.inspLocList2[a].codeName ){
              selectedMainRows[i].inspLoc = this.inspLocList2[a].code
            }
          }
          this.empNoList2.forEach(e => {
            if(e.enm == this.empNo){
              selectedMainRows[i].empNo = e.empNo
            }
          });
          let filter = []
          filter = this.custCd.split(' : ')
          selectedMainRows[i].custCd = filter[0]
          selectedMainRows[i].porNo = this.porNo
          selectedMainRows[i].porSeq = this.porSeq

        }
        // console.log('selectedMainRows: ', selectedMainRows)
        this.openLoading('searching')
       
        v80a1040Save(selectedMainRows).then(res => {
          
          if(res.body === 'Y'){
            notify(this.$t('Request Inspection saving is completed.'), 'success', 3000)
            let saveData = {
              inspDiv: this.makePopData.inspDiv,
              custCd: this.custCd,
              shipNo: this.shipNo,
              qcPart: this.reqQmPart,
              stDate: this.insDate
            }
            this.isSave(saveData)
          }else {
            this.vToastify(this.$t('Request Inspection An error was occurred : ' + "<br>" + res.body), 'warn')
          }
        })
        .catch(error => {
          this.vToastify(error, 'warn')
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
      }
    },
    btnClose(){
      this.onHidden()
    },
    cellPrepared(e){
      if(e.rowType === 'data'){
        e.cellElement.style.padding = '0px'
      }
    },
    onValueChanged2(value, cellInfo) {
      cellInfo.component.cellValue(cellInfo.rowIndex, cellInfo.columnIndex, cellInfo.value === 'Y' ? 'N' : 'Y')
    },
    uppercase(){
        this.block = this.block.toUpperCase()
    }

  }
  
}
</script>

<style lang="scss" scoped>
.btn {
  background-color: rgb(135,155,119);
  margin-right: 2px;
  font-size: 10pt;
  color: white;
}
.btnClick{
  padding: 0;
  font-size: 12px;
}
.btnClick:hover{
  color: #4980BC;
}
.subText {
  font-size: 10pt;
  font-weight: bold;
}
</style>